import {useEffect} from 'react';
import SimpleSpinner from '~/components/SimpleSpinner';
import RemoteServices from '~/constants/RemoteServices';
import rollbar from '~/vendor/rollbar';

export const SignalmizelyRedirector = () => {
  useEffect(() => {
    if (RemoteServices.signalmizely) {
      window.location.href = RemoteServices.signalmizely;
    } else {
      rollbar.error('Signalmizely URL is not configured');
    }
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
      <SimpleSpinner />
    </div>
  );
};
